<template>
  <section id="mainContainer">
      <userHeader ref ="userHeader"></userHeader>
      <section class="mid-container">
              <section class="page-banner-section" :style="{ 'background-image': `url(${require('@/assets/images/career-banner-img.jpg')})` }">
                  <div class="container">
                      <h1>{{ constants['CAREER_TEXT'] }}</h1>
                  </div>
               </section>
              <section class="career-section">
                
                    <!-- <div class="career-search">
                      <div class="container">
                          <div class="career-search-form">
                              <input type="text" placeholder="Search" />
                              <input type="button" value="Search" />
                          </div>
                      </div>
                    </div> -->
                    <div class="career-list-content">
                        <div class="container">
                             <h2>{{ constants['CURRENT_JOBS_TEXT'] }}</h2>
                             <div class="career-list">
                                 <div class="row">
                                     <div class="col-sm-4" v-for="job in jobsData" :key="job.id">
                                         <div class="career-box">
                                             <h3>{{job.jobTitle}}</h3>
                                             <div class="career-location">
                                              Location - {{job.location}}<br>
                                              Requirements - {{ job.requiredExperience.from }}-{{ job.requiredExperience.to
                                                      }} Years Exp
                                            </div>
                                            <div class="career-des">
                                             
                                                <p> {{ useStripHtml(getTruncatedText(job.shortDescription, 130)) }}</p>
                                            </div>
                                            <div class="career-read-more">
                                              <router-link :to="`/career/${job.slug}`" class="primary-btn-outline" @click="closeMenu()">Read More >></router-link>
                                                <!-- <a class="primary-btn-outline" href="career-details.html">Read More >></a> -->
                                            </div>
                                         </div>
                                     </div>
                                 </div>
                             </div>
                        </div>
                    </div>
                
              </section>
          </section>
      <userFooter></userFooter>
  </section>    
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import userHeader from "@/components/userHeader.vue";
import userFooter from "@/components/userFooter.vue";
import axios from 'axios';
import constants from '@/utils/en-US-User.json';
import { API_BASE_URL } from '@/config/api.config';

type ExperienceRange = {
  from: string;
  to: string;
};

interface Jobs{
  id: number;
  jobTitle: string;
  jobDescription: string;
  shortDescription: string;
  benefits: string;
  keyAndResponsibilities: string;
  jobRequirements: string;
  location: string;
  requiredExperience: ExperienceRange;
  jobImage: string;
  slug: string;

}
export default defineComponent({
name: "career",
data(){
  return{
      constants,
      jobsData: [] as Jobs[]
  }
},
components: {
  userHeader,
  userFooter
},
created() {
      this.fetchJobsData();
  },
methods: {
  async fetchJobsData() {
    try {
      const response = await axios.get(`${API_BASE_URL}/job/?status=1`);
      this.jobsData = response.data;
    } catch (err) {
      console.error(err);
    }
  },
  getTruncatedText(text: string, limit: number): string {
            if (text.length > limit) {
                return `${text.slice(0, limit)}...`;
            }
            return text;
        },
        useStripHtml(html : string) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
        closeMenu(){
            (this.$refs.userHeader as any).closeMenu();

        }
}
});
</script>